import React, { Component } from 'react';
import { SDate, SHr, SNavigation, SPage, SText, STheme, SView } from "servisofts-component2";
import ExpedicionEstado from '../../Components/ExpedicionEstado';
import { ScrollView } from 'react-native-gesture-handler';
export default class InfoExpedicion extends Component {
    constructor(props) {
        super(props);
        this.state = { obj: SNavigation.getParam("obj") || {} };
    }
    formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    }
    renderParada(ruta: any, index: number, total: number) {
        const isLast = index === total - 1;
        const isFirst = index === 0;

        let iconColor = "#2196F3";
        if (isFirst) iconColor = "#7B1FA2";
        if (isLast) iconColor = "#00E676";

        let fecha = "";
        const fs = (ruta?.fecha ?? "").substring(0, 16);
        
        if (fs) {
            fecha = new SDate(fs,"yyyy-MM-dd hh:mm").toString("dd MONTH HH");
        }
        return (
            <SView key={index} col={"xs-12"} style={{ minHeight: 100 }} onPress={() => {
                console.log(this.state.obj, ruta)
            }}>

                {!isLast && (<SView style={{ position: "absolute", top: 24, left: 19, bottom: 0, width: 2, borderLeftWidth: 2, borderColor: STheme.color.text, borderStyle: "dashed", opacity: 0.5 }} />)}
                <SView row col={"xs-12"}   >


                    <SView style={{ width: 40, alignItems: "center", paddingTop: 0 }}>
                        {isLast ? (
                            <SView style={{ width: 24, height: 32, justifyContent: "center", alignItems: "center", paddingTop: 0 }}>
                                <SView style={{ width: 20, height: 20, borderRadius: 10, backgroundColor: iconColor, borderWidth: 2, borderColor: iconColor }} />
                                <SView style={{ width: 0, height: 0, borderLeftWidth: 6, borderRightWidth: 6, borderTopWidth: 10, borderLeftColor: "transparent", borderRightColor: "transparent", borderTopColor: iconColor, marginTop: -2 }} />
                                <SView style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: STheme.color.background, borderWidth: 1, marginTop: -8, position: "absolute", }} />
                            </SView>
                        ) : (
                            <SView style={{ width: 20, height: 20, borderRadius: 10, backgroundColor: iconColor, borderWidth: isFirst ? 0 : 2, borderColor: isFirst ? "transparent" : STheme.color.text }} />
                        )}
                    </SView>


                    <SView flex style={{ paddingBottom: 24, paddingLeft: 10 }}>
                        {/* <SText fontSize={16} color={"#90A4AE"} bold>{this.formatDate(ruta.driver?.fecha_comparacion)}</SText> */}
                        {/* {ruta.driver?.time ? <SText fontSize={14} color={"#568399ff"} bold>{this.formatDate(ruta.driver?.time)} (Estimada)</SText> : null} */}
                        {/* {ruta.driver?.situacion_origen ? <SView row><SText fontSize={14} font={"Montserrat"} border={"#d82633"} backgroundColor={"#672d43"} color={STheme.color.text} bold style={{ padding: 0.5, borderRadius: 2, textTransform: "uppercase", }}>{ruta.driver?.situacion_origen}</SText> </SView> : null} */}
                        <SText col='xs-8' fontSize={16} color={"#90A4AE"} style={{ marginTop: 2 }}>{fecha}</SText>
                        <SText fontSize={18} color={"#90A4AE"} bold style={{ marginTop: 4 }}>{ruta.sDestinatario} </SText>
                        <SText col='xs-8' fontSize={14} color={"#90A4AE"} style={{ marginTop: 2 }}>{ruta.sDireccion} </SText>
                    </SView>
                </SView>
            </SView>
        );
    }
    render() {
        const data = this.state.obj;

        console.log("playa " + JSON.stringify(data))
        if (!data) return <SText>Cargando...</SText>;
        // const rutas = data.situaciondb?.rutas || [];
        const rutas = [...data.origen.map(a => ({ ...a, fecha: data.dtFechaCargaFormat })), ...data.destinos.map(a => ({ ...a, fecha: data.dtFechaDescargaFormat }))];
        return <SPage title={"Expediciones"} disableScroll center>
            <SView col={"xs-12"} flex style={{ backgroundColor: "#001529", padding: 16 }}>
                <SView col={"xs-12"} center style={{ marginBottom: 20 }}>
                    <SText fontSize={20} color={STheme.color.text}>Detalle Expedición</SText>
                </SView>
                <SView row col={"xs-12"} style={{ alignItems: "center", marginBottom: 10 }}>
                    <SText fontSize={16} color={STheme.color.text} bold>Nº Exped: </SText>
                    <SText fontSize={16} color={STheme.color.text} style={{ marginLeft: 5 }}>{data.lExpedicionReal_id}</SText>
                    <SView flex />
                    <ExpedicionEstado estado={data.estado} />
                </SView>
                <SView col={"xs-12"} style={{ marginBottom: 10 }}>
                    <SText fontSize={18} color={STheme.color.text} bold>Cliente: {data.cliente?.sRazonSocial}</SText>
                </SView>

                <SView col={"xs-12"} flex backgroundColor='transparent'>
                    <ScrollView>
                        {rutas.map((ruta: any, index: number) => this.renderParada(ruta, index, rutas.length))}
                    </ScrollView>
                </SView>
                <SView row col={"xs-12"} style={{ marginTop: 20, paddingTop: 20, borderTopWidth: 1, borderColor: "rgba(255,255,255,0.1)" }}>
                    <SView col={"xs-6"}>
                        <SView row style={{ marginBottom: 4 }}>
                            <SText color={STheme.color.text} fontSize={14}>Pedido: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.sNumExpedicion}</SText>
                        </SView>
                        <SView row>
                            <SText color={STheme.color.text} fontSize={14}>Metros: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.lLargo}</SText>
                        </SView>
                        <SView row>
                            <SText color={STheme.color.text} fontSize={14}>Tractora: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.sTractora}</SText>
                        </SView>
                    </SView>
                    <SView col={"xs-6"} style={{ alignItems: "flex-end" }}>
                        <SView row style={{ marginBottom: 4 }}>
                            <SText color={STheme.color.text} fontSize={14}>Kilos: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.lAlto}</SText>
                        </SView>
                        <SView row>
                            <SText color={STheme.color.text} fontSize={14}>Palets: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.lAncho}</SText>
                        </SView>
                        <SView row>
                            <SText color={STheme.color.text} fontSize={14}>Remolque: </SText>
                            <SText color={STheme.color.text} fontSize={14} style={{ marginLeft: 5 }}>{data.sRemolque}</SText>
                        </SView>
                    </SView>
                </SView>
            </SView>
        </SPage >
    }
}